import { Menu, Portal } from "@chakra-ui/react"
import { forwardRef, ReactNode } from "react"

interface DropdownProps {
  trigger: ReactNode
  children: ReactNode
  positioning?: "bottom-start" | "bottom-end" | "top-start" | "top-end" | "right-start" | "right-end"
}

export const Dropdown = ({ trigger, children, positioning = "bottom-end" }: DropdownProps) => {
  return (
    <Menu.Root positioning={{ placement: positioning }}>
      <Menu.Trigger asChild>
        {trigger}
      </Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content>
            {children}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  )
}

export const DropdownItem = forwardRef<HTMLDivElement, { children: ReactNode; onClick?: () => void; disabled?: boolean }>(
  ({ children, onClick, disabled }, ref) => {
    return (
      <Menu.Item ref={ref} onClick={onClick} disabled={disabled}>
        {children}
      </Menu.Item>
    )
  }
)

DropdownItem.displayName = "DropdownItem"

export const DropdownSeparator = () => {
  return <Menu.Separator />
}

Dropdown.Item = DropdownItem
Dropdown.Separator = DropdownSeparator
